import React from "react";
import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do you really come to me?",
    a: "Yes — we're 100% mobile. We bring the full detailing setup straight to your home or workplace, anywhere in our service area. You don't have to drive anywhere or wait around a shop.",
  },
  {
    q: "What do you need at my location?",
    a: "Just safe access to your vehicle and a bit of room to work around it. Access to a standard power outlet and water spigot is helpful, but not always required — if you're unsure, add a note when you book and we'll sort it out.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Williams, IN and stay fully mobile across Lawrence, Orange and Monroe counties — including Bedford, Mitchell, Oolitic, Springville, Orleans, Paoli, French Lick and Bloomington. A little further out? Call us at (812) 583-4516 and we'll let you know if we can make it work.",
  },
  {
    q: "How do I pay?",
    a: "Payment is due once the detail is complete and you're happy with the results. We'll confirm accepted payment methods when we call to lock in your appointment.",
  },
  {
    q: "How far ahead should I book?",
    a: "A few days' notice is ideal so you get your preferred date and time. Only one appointment is taken per time slot, so popular days fill up fast.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq" className="relative overflow-hidden border-t border-white/10 bg-background px-6 py-24 md:px-12 md:py-32">
    <div className="glow-teal right-1/4 top-1/3 h-[360px] w-[360px] bg-purple-500/12" />
    <div className="relative mx-auto grid max-w-[1500px] grid-cols-1 gap-16 md:grid-cols-12">
      <div className="md:col-span-4">
        <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-primary">/ Questions</span>
        <h2 className="mt-6 font-cabinet text-4xl font-black uppercase leading-none tracking-tighter md:text-6xl">
          <span className="gradient-text">Good To<br />Know</span>
        </h2>
        <p className="mt-8 max-w-sm text-base leading-relaxed text-zinc-400">
          Everything you need to know before your mobile detail. Still curious? Call us at (812) 583-4516.
        </p>
      </div>

      <div className="md:col-span-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
                <AccordionTrigger className="py-6 text-left font-cabinet text-xl font-bold uppercase tracking-tight text-white hover:text-primary hover:no-underline md:text-2xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-zinc-400">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </div>
  </section>
);
